import React from 'react'
import Nav from '../Components/Nav'
import Footer from '../Components/Footer'
import ClinicDetailsMain from '../Components/ClinicDetailsMain'
import { slides ,doctorDetails,clinicDetails ,isActive} from '../Components/Lists/mindVisionClinic'
import GoToTop from '../Components/GoToTop'

const MindVisionClinic = () => {
  return (
    <>
    <Nav/>
    <ClinicDetailsMain slides={slides} 
    doctorDetails={doctorDetails} 
    clinicDetails={clinicDetails}
    isActive={isActive}
    />
    <Footer/>
    <GoToTop/>
    </>
  )
}

export default MindVisionClinic